import React, { useState, useEffect } from 'react';
import './UpdateBanner.css';

function UpdateBanner() {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    const reg = navigator.serviceWorker?.controller
      ? navigator.serviceWorker.getRegistration()
      : null;
    if (!reg) return;

    const checkWaiting = (r) => {
      if (r?.waiting) setWaiting(r.waiting);
    };

    navigator.serviceWorker.getRegistration().then((r) => {
      if (!r) return;
      checkWaiting(r);
      r.addEventListener('updatefound', () => {
        const sw = r.installing;
        if (!sw) return;
        sw.addEventListener('statechange', () => {
          if (sw.state === 'installed' && navigator.serviceWorker.controller) {
            setWaiting(sw);
          }
        });
      });
    });

    const onControllerChange = () => window.location.reload();
    navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    return () => navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
  }, []);

  const handleUpdate = () => {
    if (waiting) {
      waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  if (!waiting) return null;

  return (
    <div className="update-banner">
      <span className="update-banner-text">Update available</span>
      <button className="update-banner-btn" onClick={handleUpdate}>Refresh</button>
    </div>
  );
}

export default UpdateBanner;
